import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import RequirementForm from '../../components/Requirements/RequirementForm';
import Toast from '../../components/Common/Toast';

const CreateRequirement = () => {
  const navigate = useNavigate();
  const [toast, setToast] = useState({ isOpen: false, message: '', type: 'info' });

  return (
    <div className="p-6">
      <div className="max-w-5xl mx-auto">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-800">Nuevo requerimiento</h1>
          <p className="text-gray-600 mt-1">Productos y cantidades solicitadas, con o sin proveedor (sin costos)</p>
        </div>
        <RequirementForm
          isOpen={true}
          isPageMode={true}
          onClose={() => navigate('/requirements')}
          onSuccess={() => navigate('/requirements')}
        />
        <Toast
          isOpen={toast.isOpen}
          message={toast.message}
          type={toast.type}
          onClose={() => setToast({ ...toast, isOpen: false })}
        />
      </div>
    </div>
  );
};

export default CreateRequirement;


